export const HTTP_RESPONSE_ERROR = "App/HTTP/LOAD_COMPANY";
